import styled, { css } from "styled-components"

const variants = {
  primary: css`
    background: var(--navy);
    color: #fff;
    border-color: var(--navy);
    &:hover {
      background: var(--navy-deep);
      border-color: var(--navy-deep);
      color: #fff;
    }
  `,
  secondary: css`
    background: transparent;
    color: var(--navy);
    border-color: var(--navy);
    &:hover {
      background: var(--wash);
      color: var(--navy);
    }
  `,
  light: css`
    background: #fff;
    color: var(--navy);
    border-color: #fff;
    &:hover {
      background: var(--sky);
      border-color: var(--sky);
      color: var(--navy-deep);
    }
  `,
  ghost: css`
    background: transparent;
    color: #fff;
    border-color: rgba(255, 255, 255, 0.7);
    &:hover {
      border-color: #fff;
      background: rgba(255, 255, 255, 0.08);
      color: #fff;
    }
  `,
}

export const Button = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  padding: 0 1.5rem;
  border-radius: var(--radius);
  border: 2px solid transparent;
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  -webkit-appearance: none;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;
  &:hover {
    text-decoration: none;
  }
  ${({ $variant }) => variants[$variant] || variants.primary}
  ${({ $block }) => $block && `width: 100%;`}
`
